import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit"
import { getDivisa } from "api/Divisa.service"
import { DivisaReadingDtoProps } from "api/DTOs/DivisaReadingDto"
import { ImpuestoEmpresaReadingDtoProps } from "api/DTOs/ImpuestoEmpresaReadingDto"
import { AppDispatch, RootState } from "app/store"
import FacturaService from "common/services/FacturaService"
import { FormasPago } from "features/Crear/pages/FormCreacionDocumento/hooks/ConvertirDocumento/ConvertirDocumento"

const fetchDivisas = createAsyncThunk<DivisaReadingDtoProps[]>(
  "global/fetchDivisas",
  async () => {
    const data = await getDivisa()
    localStorage.setItem("divisas", JSON.stringify(data?.items))
    return data?.items || []
  }
)

const fetchFormasPago = createAsyncThunk<FormasPago[]>(
  "global/fetchFormasPago",
  async () => {
    const res = await FacturaService.getFormasDePago()
    return res.data || []
  }
)

export const fetchNeededData = createAsyncThunk<
  void,
  void,
  { dispatch: AppDispatch }
>("global/fetchGlobalData", async (_, thunkApi) => {
  await Promise.all([
    thunkApi.dispatch(fetchFormasPago()),
    thunkApi.dispatch(fetchDivisas()),
  ])
})

// Exported variable 'store' has or is using name 'GlobalState'
export interface GlobalState {
  tiposImpuestosArticulos: ImpuestoEmpresaReadingDtoProps[]
  tiposImpuestosGenerales: ImpuestoEmpresaReadingDtoProps[]
  formasPago: FormasPago[]
  loading: boolean
  divisas: DivisaReadingDtoProps[]
}

const initialState: GlobalState = {
  tiposImpuestosArticulos: [],
  tiposImpuestosGenerales: [],
  formasPago: [],
  loading: false,
  divisas: [],
}

export const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    setTiposImpuestosArticulos: (
      state,
      { payload }: PayloadAction<ImpuestoEmpresaReadingDtoProps[]>
    ) => {
      state.tiposImpuestosArticulos = payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDivisas.fulfilled, (state, { payload }) => {
        state.divisas = payload
      })
      .addCase(fetchFormasPago.fulfilled, (state, { payload }) => {
        state.formasPago = [
          {
            description: "Sin seleccionar",
            id: null,
          },
          ...payload,
        ]
      })
      .addCase(fetchNeededData.pending, (state) => {
        state.loading = true
      })
      .addCase(fetchNeededData.fulfilled, (state) => {
        state.loading = false
      })
  },
})

export const globalSelector = (state: RootState) => state.global

export const { setTiposImpuestosArticulos } = globalSlice.actions
